<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import type { WallStructure } from '~/models';
import type { MessageSchema } from '~/locales';

const { t } = useI18n < { message: MessageSchema }>();

interface Props {
  wallStructure: WallStructure;
}

defineProps<Props>();

defineEmits<{
  (e: 'selectedWallStructure', wallStructure: WallStructure): void;
}>();
</script>

<template>
  <div class="card-component" @click="$emit('selectedWallStructure', wallStructure)" :cypress-id="`wall-structure-card-${wallStructure.type}`">
    <img class="card-img" :src="wallStructure.imageURL" :alt="t(wallStructure.name)" loading="lazy" />
    <div class="card-body">
      <p class="card-title">{{ t(wallStructure.name) }}</p>
    </div>
  </div> 
</template>


<style lang="scss">
$card-size: 140px;

.card-component {
  display: grid;
  grid-template-rows: 1fr max-content;
  align-items: center;
  box-sizing: content-box;
  border: 1px solid var(--bds-brand-primary-color);
  width: 100%;
  max-width: $card-size;
  cursor: pointer;

  &.active {
    border: 3px solid var(--bds-brand-primary-color);

    .card-body {
      border-top: 3px solid var(--bds-brand-primary-color);
    }

    .card-title {
      font-weight: bold;
    }
  }
}

.card-img {
  width: inherit;
  height: $card-size;
  mix-blend-mode: darken;
}

.card-body {
  border-top: 1px solid var(--bds-brand-primary-color);
  display: grid;
  height: 4rem;
  text-align: center;
}

.card-title {
  margin: auto;
  color: var(--bds-brand-primary-color);
  padding: 0 1rem;
}
</style>
